<style scoped>
</style>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import { simpleComputed } from '@state/helpers'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
	components: { VueDraggableResizable },
	props: {

	},
	data() {
		return {
			x: 40,
			y: 50,
		}
	},
	computed : {
		...simpleComputed,
		getPlayerURL() {
			return this.player.isOpen ? process.env.VUE_APP_PLAYER : 'about:blank'
		},
	},
	mounted() {
	},
	updated() {
	},
	methods : {
		playerClose(e) {
			this.playerHide();
		},

    onDrag(x, y) {
      this.x = x
      this.y = y
    }
	}

}
</script>

<template>
	<div :style="{ display: player.isHide ? 'none' : 'block' }" style="position: fixed; z-index:90000">
		<vue-draggable-resizable :x="x" :y="y" :resizable="false" @dragging="onDrag">
			<div id="playerArea" style="width:350px; height:527px; position:fixed; z-index:90000">
				<div style="backgroundColor:#FFFFFF">
					<i class="ti-close" style="font-size:25px; cursor:pointer" @click="playerClose"></i>
				</div>
				<iframe :src="getPlayerURL" title="iframe" 
					sandbox="allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation"
					style="width: 100%; height:100%"
					frameBorder='0' framespacing='0' marginHeight='0' marginWidth='0' scrolling='no' vspace='0'></iframe>
			</div>
		</vue-draggable-resizable>	
	</div>
</template>
